<template>
  <div class="main-ct">
    <div>
      <p class="header-paragraph">
        {{ $t('Gamification_Hear_From_Our_Customers') }}
      </p>
    </div>
    <div class="customer-quote-ct">
      <div>
        <img
          src="@/img/gamification/xp-tb-customer-grosvenor.png"
          :alt="$t('Gamification_Hear_From_Our_Customers_Client')"
        />
      </div>
      <div class="quote-ct">
        <p class="quote-paragraph">
          {{ $t('Gamification_Hear_From_Our_Customers_Quote') }}
        </p>
        <p class="quote-person">
          {{ $t('Gamification_Hear_From_Our_Customers_Quote_Quoter') }}
        </p>
        <p class="quote-person-role">
          {{ $t('Gamification_Hear_From_Our_Customers_Quote_Quoter_Role') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamificationHearFromOurCustomers'
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 65px;
  gap: 20px;
  background-color: #fff;
}

.header-paragraph {
  font-size: 24px;
  color: #5c6374;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
}

.customer-quote-ct {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 45px;
}

.quote-ct {
  width: 630px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}

.quote-paragraph {
  color: #1d87c9;
  font-size: 24px;
  font-style: italic;
  font-weight: 600;
  line-height: 32px;
}

.quote-person {
  color: #5c6374;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.quote-person-role {
  color: #7e8596;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationHearFromOurCustomers.vue